import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TileIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TileIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.5943 2.17994H6.53175C6.20816 2.17994 5.94581 2.44228 5.94581 2.76588V5.94557H2.76612C2.44253 5.94557 2.18018 6.20791 2.18018 6.53151V21.594C2.18018 21.9176 2.44252 22.18 2.76612 22.18H17.8286C18.1522 22.18 18.4146 21.9176 18.4146 21.594V18.4143H21.5943C21.9179 18.4143 22.1802 18.152 22.1802 17.8284V2.76587C22.1802 2.44228 21.9179 2.17994 21.5943 2.17994ZM7.1177 3.35182H12.6484L10.0547 5.94557H7.1177V3.35182ZM14.063 3.59452L16.4141 5.94558H11.712L14.063 3.59452ZM3.35206 7.11744H9.68695C9.40472 10.4808 6.71546 13.1701 3.35206 13.4523V7.11744ZM3.35206 21.0081V14.6732C6.71546 14.9554 9.40472 17.6447 9.68695 21.0081H3.35206ZM5.79327 14.0628C7.83812 13.2379 9.47249 11.6035 10.2974 9.55866C11.1223 11.6035 12.7566 13.2379 14.8015 14.0628C12.7566 14.8877 11.1223 16.522 10.2974 18.5669C9.4725 16.522 7.83812 14.8877 5.79327 14.0628ZM17.2427 21.0081H10.9078C11.19 17.6447 13.8793 14.9554 17.2427 14.6732V21.0081ZM17.2427 13.4523C13.8793 13.1701 11.19 10.4809 10.9078 7.11745H17.2427V13.4523ZM21.0083 17.2425H18.4146V14.3055L21.0083 11.7117V17.2425ZM18.4146 12.6482V7.94608L20.7657 10.2971L18.4146 12.6482ZM21.0083 8.88257L15.4776 3.35182H21.0083V8.88257Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default TileIcon;
